import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TypeResponse } from '@app/shared/enum/TypeResponse';
import { MessageService } from '@app/shared/services/message.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StatusCrmCss, StatusCrmLabel } from '@app/shared/enum/StatusCrm';
import { InitAdminService } from '@app/admin/services';
import { UserCreditDebitService } from '@app/financial/services';
import { UserCreditDebitSummary } from '@app/financial/model/userCreditDebitSummary';
import { IndicationService } from '@app/marketing/services';
import { default as swal } from 'sweetalert2';
import { UtilService } from '@app/shared/services';
import { ModuleTypeCss, ModuleTypeLabel } from '@app/shared/enum';

@Component({
  templateUrl: 'indication-list.component.html',
  providers: [DatePipe],
})
export class IndicationListComponent implements OnInit {
  @ViewChild('mdContactPreRegister') mdContactPreRegister: any;
  public contacts: any = [];
  public showTable: boolean;
  public dateNow = new Date();
  dataResult: boolean = false;
  public returnMessage = '';
  closeResult: string;
  contactId: number;
  public statusCrm: string = null;

  iconCreditUse = 'fa fa-magic';
  titleCreditUse = 'Autorizar uso do crédito';

  public creditDebitSummary = new UserCreditDebitSummary();
  public indicationId: number = 0;

  public columns: Array<any> = [
    { title: 'Código', name: 'id', sort: 'asc', className: 'text-center' },
    { title: 'Nome', name: 'name', sort: 'asc' },
    { title: 'E-mail', name: 'email', sort: 'asc', className: 'text-center' },
    { title: 'Telefone', name: 'phone', sort: 'asc', className: 'text-center' },
    {
      title: 'Indicado por',
      name: 'indicationName',
      sort: 'asc',
      className: 'text-center fw-700'
    },
    {
      title: 'Origem da Indicação',
      name: 'designIndicationSource',
      sort: 'asc',
      className: 'text-center fw-700',
      isHtmlData: true,
    },
    {
      title: 'Status Atual',
      name: 'designStatus',
      sort: 'asc',
      className: 'text-center fw-700',
      isHtmlData: true,
    },
    {
      title: 'Usuário<br>Criado?',
      name: 'createdUser',
      sort: 'asc',
      className: 'text-center text-primary',
    },
    {
      title: 'Usuário<br>Já Acessou?',
      name: 'userLoggedIn',
      sort: 'asc',
      className: 'text-center text-primary',
    },
    {
      title: 'Matrícula<br>Efetivada?',
      name: 'registration',
      sort: 'asc',
      className: 'text-center text-primary',
    },
    {
      title: 'Status do<br>Crédito',
      name: 'creditStatus',
      sort: 'asc',
      className: 'text-center text-primary',
      isHtmlData: true,
    },
    {
      title: 'Última<br>Atualização',
      name: 'updatedOn',
      sort: 'asc',
      className: 'text-center font-weight-bold text-info datetime',
    },
  ];

  constructor(
    private userCreditDebitService: UserCreditDebitService,
    private indicationService: IndicationService,
    private initAdminService: InitAdminService,
    private utilService: UtilService,
    private loading: MessageService,
    private modalService: NgbModal,
    private router: Router
  ) {
    this.initAdminService.setConfigPage(false, false);
  }

  ngOnInit(): void {
    this.loading.showLoading();
    this.dataResult = false;
    this.statusCrm = null;
    this.initialyze();
  }

  initialyze() {
    this.loadIndicationsForAdmin();
    this.getUserCreditDebitSummaryForAdmin();
  }

  loadIndicationsForAdmin() {
    this.indicationService.getAllIndicationsForAdmin().subscribe(
      (response: any) => {
        if (response.typeResponse == TypeResponse.Success) {
          this.contacts = response.data;
          this.reviewDataList(this.contacts);
          this.showTable = true;
          this.returnMessage = '';
        } else {
          this.returnMessage = response.message;
          this.showTable = false;
        }
        this.loading.hideLoading();
      },
      (error: any) => {
        this.loading.hideLoading();
        this.showTable = false;
        this.returnMessage = 'Erro ao carregar os dados das indicações.';
      }
    );
  }

  getUserCreditDebitSummaryForAdmin() {
    this.userCreditDebitService.summaryForAdmin().subscribe(
      (response: any) => {
        if (response.typeResponse == TypeResponse.Success) {
          this.creditDebitSummary = response.data;
          this.returnMessage = '';
        } else {
          this.returnMessage = response.message;
        }
        this.loading.hideLoading();
      },
      (error: any) => {
        this.loading.hideLoading();
        this.returnMessage = 'Erro ao carregar os dados dos créditos/débitos dos usuários.';
      }
    );
  }

  resetStatusPage() {
    this.loading.showLoading();
    window.location.replace(window.location.href.split(';')[0]);
    window.location.reload();
  }

  reviewDataList(lista: any[]) {
    lista.forEach(function (e) {
      if (e.statusCrm >= 0) {
        let statusCrmStr = StatusCrmLabel.get(e.statusCrm);
        let statusCrmCss = StatusCrmCss.get(e.statusCrm);
        e.designStatus =
          "<span class='badge w-100 " +
          statusCrmCss +
          " badge-pill py-1 px-3'>" +
          statusCrmStr +
          '</span>';
      }

      if (e.userCreditDebit) {
        e.creditStatus = `<span class="badge badge-pill py-1 px-3 text-white bg-success">Crédito Disponível</span>`;
        if (e.userCreditDebit.creditUsed) {
          e.creditStatus = `<span class="badge badge-pill py-1 px-3 text-white bg-primary">Crédito Utilizado</span>`;
        }
      } else {
        e.creditStatus = `<span class="badge badge-pill py-1 px-3 text-white bg-secondary">Crédito Bloqueado</span>`;
      }

      if (e.userIndication) {
        e.indicationName = e.userIndication.name;

        let indicationSourceStr = ModuleTypeLabel.get(e.userIndication.module.moduleType);
        let indicationSourceCss = ModuleTypeCss.get(e.userIndication.module.moduleType);
        e.designIndicationSource =
          "<span class='badge w-100 " +
          indicationSourceCss +
          " badge-pill py-1 px-3'>" +
          indicationSourceStr +
          '</span>';
      }
    });
    this.contacts = lista;
  }

  private getDismissReason(reason: any): string {
    if (reason === 3) {
      return 'by opening next modal';
    } else {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else if (reason === 2) {
        return 'by clicking on a close button';
      } else {
        return `with: ${reason}`;
      }
    }
  }

  newIndication(content: any) {
    this.modalService.dismissAll();
    this.open(content);
  }

  edit(row: any): void {
    this.loading.showLoading();
    this.router.navigate([
      '/marketing/contactbysite',
      { id: row.id, edit: true },
    ]);
  }

  preview(row: any): void {
    this.loading.showLoading();
    this.router.navigate([
      '/marketing/contactbysite',
      { id: row.id, preview: true },
    ]);
  }

  onCreditUse(row: any) {
    if (!row.userCreditDebit) {
      swal({
        type: 'warning',
        title: 'Crédito está bloqueado',
        text: 'Não é possível utilizar o crédito selecionado!',
        showConfirmButton: true,
      })
      return;
    }

    if (row.userCreditDebit?.creditUsed == true) {
      swal({
        type: 'warning',
        title: 'Crédito já utilizado',
        text: 'Não é possível utilizar o crédito selecionado!',
        showConfirmButton: true,
      })
      return;
    }

    if (!row.userCreditDebit?.amount) {
      swal({
        type: 'warning',
        title: 'Crédito não disponível',
        text: 'Não é possível utilizar o crédito selecionado!',
        showConfirmButton: true,
      })
      return;
    }

    if (row.userCreditDebit?.amount <= 0) {
      swal({
        type: 'warning',
        title: 'Crédito inválido',
        text: 'Não é possível utilizar o crédito selecionado!',
        showConfirmButton: true,
      })
      return;
    }

    this.loading.showLoading();

    swal({
      title: 'Utilização de Crédito',
      html:
        'Confirma a utilização do crédito de <strong>' +
        this.utilService.formatCurrency(row.userCreditDebit.amount) +
        '</strong>?<br>' +
        '<small>Ao confirmar o crédito será utilizado e não poderá ser resgatado novamente!</small>',
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Sim, utilizar crédito',
    }).then(
      (willCreditUsed) => {
        if (willCreditUsed.value === true) {
          row.userCreditDebit.creditUsed = true;
          this.userCreditDebitService.patch(row.userCreditDebit.id, row.userCreditDebit).subscribe(
            (response: any) => {
              if (
                'typeResponse' in response &&
                response['typeResponse'] === TypeResponse.Success
              ) {
                swal({
                  type: 'success',
                  title: 'Crédito utilizado com sucesso!',
                  showConfirmButton: false,
                  timer: 1500,
                }).then((result) => {
                  this.resetStatusPage();
                });
              } else if (
                'typeResponse' in response &&
                response['typeResponse'] === TypeResponse.Alert
              ) {
                swal({
                  type: 'warning',
                  title: 'Não foi possível utilizar o crédito!',
                  text: response.message,
                  showConfirmButton: true,
                  //timer: 1500
                }).then((result) => {});
              } else if (
                'typeResponse' in response &&
                response['typeResponse'] === TypeResponse.Error
              ) {
                swal({
                  type: 'error',
                  title: 'Erro ao tentar utilizar o crédito.',
                  text: response.message,
                  showConfirmButton: true,
                  //timer: 1500
                }).then((result) => {
                  this.resetStatusPage();
                });
              }
            },
            (error: any) => {
              swal({
                type: 'error',
                title: 'Erro ao tentar utilizar o crédito.',
                showConfirmButton: false,
                timer: 1500,
              }).then((result) => {
                this.loading.hideLoading();
                window.location.reload();
              });
            }
          );
        }
      },
      (error: any) => {
        // expiração do token
        if (error.error.error === 'invalid_token') {
          this.router.navigate(['/auth/login']);
        } else {
          swal({
            type: 'error',
            title: 'Erro ao tentar utilizar o crédito.',
            showConfirmButton: false,
            timer: 1500,
          }).then((result) => {
            this.loading.hideLoading();
            window.location.reload();
          });
        }
      }
    );
    this.loading.hideLoading();
  }

  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' })
    .result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  dismissModal() {
    this.modalService.dismissAll();
  }
}
